import * as React from 'react';
import {type SpringIconType} from '@packages/systems/spring';

type IconProps = React.ComponentPropsWithoutRef<SpringIconType>;

type BaseIconProps = Omit<
  React.ComponentPropsWithoutRef<SpringIconType>,
  'children'
>;
type BaseIcon = React.ForwardRefExoticComponent<
  BaseIconProps & React.RefAttributes<HTMLDivElement>
>;

export const pickBreakpointIcon = (
  Icon16: SpringIconType,
  Icon24?: SpringIconType
) => {
  const Icon24Component = Icon24 || Icon16;

  const Small = React.forwardRef<HTMLDivElement, IconProps>((props, ref) => {
    return <Icon16 {...props} size={16} ref={ref} />;
  });

  const Large = React.forwardRef<HTMLDivElement, IconProps>((props, ref) => {
    return <Icon24Component {...props} size={24} ref={ref} />;
  });

  return {
    Small,
    Large,
  } as {
    Small: BaseIcon;
    Large: BaseIcon;
  };
};
